<div
  class="image-upload-container"
  [class.variant-avatar]="variant() === 'avatar'"
>
  <input
    #fileInput
    type="file"
    (change)="onFileSelected($event)"
    accept="image/*"
    hidden
  />

  @if (displayedImage) {
    <div class="image-preview" tabindex="0">
      <img [src]="displayedImage | imageUrl" [alt]="altText()" />
      <div class="overlay">
        <button
          type="button"
          class="action-btn change"
          (click)="triggerUpload(); $event.stopPropagation()"
          [attr.aria-label]="changeLabel()"
          [title]="changeLabel()"
        >
          <mat-icon>edit</mat-icon>
          <span>{{ changeLabel() }}</span>
        </button>
        <button
          type="button"
          class="action-btn remove"
          (click)="onRemoveImage($event)"
          aria-label="Remove image"
          title="Remove image"
        >
          <mat-icon>delete</mat-icon>
          <span>Remove</span>
        </button>
      </div>
    </div>
  } @else {
    <div
      class="upload-placeholder"
      (click)="triggerUpload()"
      (keydown.enter)="triggerUpload()"
      (keydown.space)="triggerUpload()"
      tabindex="0"
      role="button"
      [attr.aria-label]="uploadLabel()"
    >
      <mat-icon>add_photo_alternate</mat-icon>
      <span>{{ uploadLabel() }}</span>
    </div>
  }
</div>

@if (hint()) {
  <p class="hint">{{ hint() }}</p>
}
